(function () {
  'use strict';

  const { ProductForm, QuantitySelector, VariantSelect, ProductModelViewerManager, subEvents, PUB_SUB_EVENTS } = window.Universe;

  class QuickAdd {
    constructor(card, container) {
      this.init(card, container);
    }

    setup() {
      this.DOM.viewBtns = this.DOM.card.querySelectorAll('.js-view-card');
      this.DOM.viewBtns?.forEach((viewBtn) => {
        viewBtn.addEventListener('click', this.createModal);
      });

      this.openerElement = null;
      this.focusTrapActive = false;
    }

    setupVariantSelects() {
      this.variantSelects = [];
      const selects = this.DOM.quickAdd.querySelectorAll('.js-variant-select');
      selects.forEach((select) => {
        const variantSelect = new VariantSelect(select);
        this.variantSelects.push(variantSelect);
      });
      if (!this.variantSelectHandler) {
        this.variantSelectHandler = (ref) => {
          const data = ref.data;
          const option = data.target;
          const variantURL =
            option.dataset.productUrl || option.dataset.url || this.variantSelects[0].DOM.wrap.dataset.url;
          const variantId = option.dataset.id || option.dataset.optionValueId;
          if (variantURL && variantId) {
            this.fetchURL(variantURL + '&view=quick-add', true, variantId);
          }
        };

        this.variantSelectUnsub = subEvents.subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.variantSelectHandler
        );
      }
    }

    setupModal(reinit, variantId) {
      if (this.DOM.quickAdd) {
        setTimeout(() => { this.DOM.quickAdd.classList.add('quick-add--open'); }, reinit ? 0 : 50);

        this.DOM.form = this.DOM.quickAdd.querySelector('.js-quick-product-form');
        this.form = new ProductForm(this.DOM.form);

        this.DOM.quickAdd.addEventListener('click', this.destroyModal);

        this.DOM.closeBtn = this.DOM.quickAdd.querySelector('.js-quick-add-close');
        if (this.DOM.closeBtn) {
          this.DOM.closeBtn.addEventListener('click', () => this.closeModal());
        }

        document.addEventListener('keydown', this.handleEscapeKey);

        this.qtySelector = new QuantitySelector(this.DOM.quickAdd);

        this.setupVariantSelects();
        this.setupModelViewers();
        this.enableModalA11y();

        this.cartUpdateUnsub = subEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
      }
    }

    setupModelViewers() {
      if (this.DOM.quickAdd) {
        this.modelViewerManager = new ProductModelViewerManager(this.DOM.quickAdd);
      }
    }

    appendModal(html, reinit, variantId) {
      if (reinit && this.DOM.quickAdd) {
        this.DOM.quickAdd.removeEventListener('click', this.destroyModal);
        this.DOM.quickAdd = undefined;

        if (this.modelViewerManager) {
          this.modelViewerManager.destroy();
          this.modelViewerManager = null;
        }
      }

      const quickAddWrapper = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-quick-add-wrapper');

      if (quickAddWrapper) {
        this.DOM.container.innerHTML = '';
        this.DOM.container.appendChild(quickAddWrapper);
        this.DOM.quickAdd = this.DOM.container.querySelector('.js-quick-add');

        document.body.classList.add('modal-open');

        if (reinit) {
          this.DOM.quickAdd.classList.add('quick-add--reinit');
          this.setupModal(true, variantId);
          return;
        }

        this.setupModal(false, variantId);
      }
    }

    fetchURL(url, reinit, variantId) {
      fetch(url)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          this.appendModal(html, reinit, variantId);
        })
        .catch((error) => {
          console.error('Error loading the product form:', error);
        });
    }

    closeModal() {
      if (this.DOM.quickAdd) {
        this.disableModalA11y();

        if (this.cartUpdateUnsub) {
          this.cartUpdateUnsub();
          this.cartUpdateUnsub = undefined;
        }

        this.DOM.quickAdd.classList.remove('quick-add--reinit');
        this.DOM.quickAdd.classList.remove('quick-add--open');
        this.DOM.quickAdd.removeEventListener('click', this.destroyModal);
        document.removeEventListener('keydown', this.handleEscapeKey);

        const cardToFocus = this.openerCard;
        const tabindexWasAdded = this.openerCardTabindexAdded;

        this.form.destroy();
        this.form = undefined;

        this.qtySelector.destroy();
        this.qtySelector = undefined;

        if (this.modelViewerManager) {
          this.modelViewerManager.destroy();
          this.modelViewerManager = null;
        }

        this.DOM.quickAdd = undefined;

        const animationDuration = 500;
        setTimeout(() => {
          document.body.classList.remove('modal-open');

          if (this.DOM.container) {
            this.DOM.container.innerHTML = '';
          }

          if (cardToFocus && typeof cardToFocus.focus === 'function') {
            cardToFocus.focus();
            if (tabindexWasAdded) {
              cardToFocus.removeAttribute('tabindex');
            }
          }
        }, animationDuration);
      }
    }

    destroy() {
      if (this.DOM) {
        this.qtySelector?.destroy();
        this.DOM.viewBtns?.forEach((viewBtn) => {
          viewBtn.removeEventListener('click', this.createModal);
        });

        if (this.variantSelects) {
          this.variantSelects.forEach((vs) => { vs.destroy(); });
          this.variantSelects = undefined;
        }
        if (this.variantSelectUnsub) {
          this.variantSelectUnsub();
          this.variantSelectUnsub = undefined;
        }
        if (this.modelViewerManager) {
          this.modelViewerManager.destroy();
          this.modelViewerManager = null;
        }
      }
    }

    init(card, container) {
      if (card && container) {
        this.DOM = {};

        this.DOM.card = card;
        this.DOM.container = container;

        this.handleCartUpdate = (data) => {
          if (
            data.source === 'product-form' &&
            this.DOM.quickAdd &&
            this.DOM.quickAdd.classList.contains('quick-add--open')
          ) {
            this.closeModal();
          }
        };

        this.createModal = (e) => {
          e.stopPropagation();
          e.preventDefault();

          this.openerCard = this.DOM.card;
          if (!this.openerCard.hasAttribute('tabindex')) {
            this.openerCard.setAttribute('tabindex', '-1');
            this.openerCardTabindexAdded = true;
          }

          const productHandle = this.DOM.card.dataset.handle;
          if (productHandle.includes('?')) {
            this.fetchURL(productHandle + '&view=quick-add');
          } else {
            this.fetchURL(productHandle + '?view=quick-add');
          }
        };

        this.destroyModal = (e) => {
          if (e.target === e.currentTarget && this.DOM.quickAdd) {
            this.closeModal();
          }
        };

        this.handleEscapeKey = (e) => {
          if (e.key === 'Escape' && this.DOM.quickAdd && this.DOM.quickAdd.classList.contains('quick-add--open')) {
            this.closeModal();
          }
        };

        this.handleTabTrap = (e) => {
          if (!this.focusTrapActive || !this.DOM.quickAdd) return;
          if (e.key !== 'Tab') return;
          const focusables = this.getFocusableElements(this.DOM.quickAdd);
          if (!focusables.length) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        };

        this.setup();
      }
    }

    getFocusableElements(root) {
      if (!root) return [];
      const selectors = [
        'a[href]',
        'area[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'iframe',
        'object',
        'embed',
        '[contenteditable]',
        '[tabindex]:not([tabindex="-1"])',
      ];
      return Array.from(root.querySelectorAll(selectors.join(','))).filter(
        (el) => { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    focusFirstInModal() {
      const focusables = this.getFocusableElements(this.DOM.quickAdd);
      const closeBtn = this.DOM.quickAdd.querySelector(
        '.js-quick-add-close, [aria-label*="close" i], button[class*="close"]'
      );
      const target = closeBtn || focusables[0];
      if (target && typeof target.focus === 'function') {
        target.focus();
      }
    }

    setBackgroundInert(enable) {
      const bodyChildren = Array.from(document.body.children);
      this.backgroundNodes = bodyChildren.filter((node) => {
        return node !== this.DOM.container && node !== this.DOM.quickAdd;
      });

      const supportsInert = 'inert' in HTMLElement.prototype;
      this.backgroundNodes.forEach((node) => {
        if (enable) {
          if (supportsInert) {
            node.inert = true;
          } else {
            node.setAttribute('aria-hidden', 'true');
          }
        } else {
          if (supportsInert) {
            node.inert = false;
          } else {
            node.removeAttribute('aria-hidden');
          }
        }
      });
    }

    enableModalA11y() {
      this.setBackgroundInert(true);
      this.focusTrapActive = true;
      document.addEventListener('keydown', this.handleTabTrap);
      setTimeout(() => { this.focusFirstInModal(); }, 500);
    }

    disableModalA11y() {
      this.setBackgroundInert(false);
      this.focusTrapActive = false;
      document.removeEventListener('keydown', this.handleTabTrap);
    }
  }

  window.Universe = window.Universe || {};
  window.Universe.QuickAdd = QuickAdd;
})();
